import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const uninterceptedAxiosInstance = axios.create();
const baseAxios = axios.create();
const adminAxios = axios.create();

baseAxios.defaults.baseURL = BASE_URL;
adminAxios.defaults.baseURL = BASE_URL + "/master-admin";

adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("masterToken");
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

adminAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    console.log("ERRROROR", error);
    if (error.response?.status === 401) {
      console.log("Unauthorized");
      localStorage.removeItem("masterToken");
      window.location.href = "/";
    }
    // return new Error(error);
    return Promise.reject(error);
  }
);

export const adminLogin = (body) => {
  return baseAxios.post(`/auth/master-admin`, body);
};

export const adminMagicVerify = (body) => {
  return baseAxios.post(`/auth/admin-magic`, body);
};

export const fetchOrganizations = () => {
  return adminAxios.get(`/organization`);
};

export const createOrganization = (body) => {
  return adminAxios.post(`/organization`, body);
};

export const updateOrganizationInfo = (body) => {
  return adminAxios.put(`/organization`, body);
};

export const updateOrganizationContactInfo = (body) => {
  return adminAxios.post(`/organization-contact`, body);
};

export const updateOrganizationTheme = (body) => {
  return adminAxios.patch(`/organization-theme`, body);
};

export const getOrganizationProfileTypes = (id) => {
  return adminAxios.get(`/profile-types/${id}`);
};

export const createOrganizationProfileType = (id, body) => {
  return adminAxios.post(`/profile-types/${id}`, body);
};

export const updateOrganizationProfileType = (id, body) => {
  return adminAxios.put(`/profile-types/${id}`, body);
};

export const getProfileTypePages = (id) => {
  return adminAxios.get(`/pages/${id}`);
};

export const getProfileTypeFields = (id) => {
  return adminAxios.get(`/fields/${id}`);
};

export const fetchAdmins = () => {
  return adminAxios.get("");
};

export const getAdminProfileById = (id) => {
  return adminAxios.get(`/${id}`);
};

export const createAdmin = (body) => {
  return adminAxios.post("", body);
};

export const updateAdminById = (body, id) => {
  return adminAxios.put(`/${id}`, body);
};

export const createAccessKey = (body, organisation) => {
  return adminAxios.post(`/organization/${organisation}/access-token`, body);
};

export const getAccessKeyByOrg = (organisation) => {
  return adminAxios.get(`/organization/${organisation}/access-token`);
};

export const updateAccesKey = (body, organisation, id) => {
  return adminAxios.put(`/organization/${organisation}/access-token/${id}`, body);
};

export const deleteAccesKey = (organisation, id) => {
  return adminAxios.delete(`/organization/${organisation}/access-token/${id}`);
};

export const getRegions = (organisation) => {
  return adminAxios.get(`/regions/${organisation}`);
};

export const createRegion = (body, organisation) => {
  return adminAxios.post(`/regions/${organisation}`, body);
};

export const updateRegion = (body, organisation) => {
  return adminAxios.patch(`/regions/${organisation}`, body);
};

export const deleteRegion = (organisation, body) => {
  return adminAxios.delete(`/regions/${organisation}`, { params: body });
};

export const getAcademies = (organisation) => {
  return adminAxios.get(`/academy/${organisation}`);
};

export const createAcademy = (body, organisation) => {
  return adminAxios.post(`/academy/${organisation}`, body);
};

export const updateAcademy = (body, organisation) => {
  return adminAxios.patch(`/academy/${organisation}`, body);
};

export const deleteAcademy = (organisation, body) => {
  return adminAxios.delete(`/academy/${organisation}`, { params: body });
};

export const getEstablishments = (organisation) => {
  return adminAxios.get(`/establishment/${organisation}`);
};

export const createEstablishment = (body, organisation) => {
  return adminAxios.post(`/establishment/${organisation}`, body);
};

export const updateEstablishment = (body, organisation) => {
  return adminAxios.patch(`/establishment/${organisation}`, body);
};

export const deleteEstablishment = (organisation, body) => {
  return adminAxios.delete(`/establishment/${organisation}`, {
    params: body
  });
};

export const getProfessionMaps = (organization) => {
  return adminAxios.get(`/profession-map/${organization}`);
};

export const saveProfessionMap = (organization, body) => {
  return adminAxios.post(`/profession-map/${organization}`, body);
};

export const deleteProfessionMap = (organization, _id) => {
  return adminAxios.delete(`/profession-map/${organization}`, { params: { _id } });
};

export const createService = (body, organization) => {
  return adminAxios.post(`/services/${organization}`, body);
};

export const updateService = (body, organization) => {
  return adminAxios.put(`/services/${organization}`, body);
};

export const getServices = (organisation) => {
  return adminAxios.get(`/services/${organisation}`);
};

export const getPermissions = () => {
  return adminAxios.get(`/permissions`);
};

export const getAdminProfile = () => {
  return adminAxios.get(`/me`);
};

export const getServiceDetails = (organisation, serviceId) => {
  return adminAxios.get(`/service-details/${organisation}`, {
    params: { serviceId }
  });
};

export const createNewProfileType = (id, body) => {
  return adminAxios.post(`/profile-type/${id}`, body);
};

export const updateProfileType = (id, body) => {
  return adminAxios.put(`/profile-type/${id}`, body);
};

export const getPersonalInfomationFormValidFields = (organizationId) => {
  return adminAxios.get(`/valid-input-fields/${organizationId}`);
};

export const getTeachersPortal = (id, organization) => {
  return adminAxios.get(`/teachers-portal/${organization}/${id}`);
};

export const updateTeachersPortal = (id, organization, body) => {
  return adminAxios.put(`/teachers-portal/${organization}/${id}`, body);
};

export const getSystemAdminUserGroups = (organization) => {
  return adminAxios.get(`/system-admin-groups/${organization}`);
};

export const getProfessions = (organization, accessibleTo) => {
  return baseAxios.get(`/public/professions`, { params: { organization, accessibleTo } });
};

export const getProfileTypes = (organization) => {
  return adminAxios.get(`/profile-types/${organization}`);
};

export const getProfessionsAccessibleToOptions = (organization) => {
  return baseAxios.get(`/public/professions-accessible-to-options`, { params: { organization } });
};

// Get Uplaoding File Link and Final Name
export const getUploadingFileData = (body) => {
  return baseAxios.post("/uploader/upload", { ...body, keepOriginal: true });
};

// Upload File to the Link
export const uploadFileToAWS = (url, file, contentType, progressCallback = null) => {
  return uninterceptedAxiosInstance.put(url, file, {
    headers: {
      "Content-type": contentType
    },
    onUploadProgress: progressCallback ? progressCallback : undefined
  });
};

export const getOrgStrength = (organization) => {
  return adminAxios.get(`/strengths/${organization}`);
};

export const addStrength = (organisation, body) => {
  return adminAxios.post(`/strengths/${organisation}`, body);
};

export const updateStrength = (organisation, body) => {
  return adminAxios.patch(`/strengths/${organisation}`, body);
};

export const deleteStrength = (organisation, body) => {
  return adminAxios.delete(`/strengths/${organisation}`, { params: body });
};

export const getOrgRoles = (organization) => {
  return adminAxios.get(`/roles/${organization}`);
};

export const addRole = (organisation, body) => {
  console.log("roles body ", body);
  return adminAxios.post(`/roles/${organisation}`, body);
};

export const updateRole = (organisation, body) => {
  return adminAxios.patch(`/roles/${organisation}`, body);
};

export const deleteRole = (organisation, body) => {
  return adminAxios.delete(`/roles/${organisation}`, { params: body });
};

export const getRegionalEvents = (organisation) => {
  return adminAxios.get(`/regional-events/${organisation}`);
};

export const createRegionalEvent = (body, organisation) => {
  return adminAxios.post(`/regional-events/${organisation}`, body);
};

export const updateRegionalEventOrder = (organisation, body) => {
  return adminAxios.put(`/regional-events/${organisation}`, body);
};

export const updateRegionalEvent = (organisation, id, body) => {
  return adminAxios.put(`/regional-events/${organisation}/${id}`, body);
};

export const deleteRegionalEvent = (organisation, id) => {
  return adminAxios.delete(`/regional-events/${organisation}/${id}`);
};

export const getParticipantLocations = (organisation) => {
  return adminAxios.get(`/participant-locations/${organisation}`);
};

export const createParticipantLocation = (body, organisation) => {
  return adminAxios.post(`/participant-locations/${organisation}`, body);
};

export const updateParticipantLocationOrder = (organisation, body) => {
  return adminAxios.put(`/participant-locations/${organisation}`, body);
};

export const updateParticipantLocation = (organisation, id, body) => {
  return adminAxios.put(`/participant-locations/${organisation}/${id}`, body);
};

export const deleteParticipantLocation = (organisation, id) => {
  return adminAxios.delete(`/participant-locations/${organisation}/${id}`);
};

export const getBadgeUIConfig = (organisation) => {
  return adminAxios.get(`/badge-ui-config/${organisation}`);
};

export const updateBadgeUIConfig = (organisation, body) => {
  return adminAxios.put(`/badge-ui-config/${organisation}`, body);
};

export const getEmailTemplates = (organisation) => {
  return adminAxios.get(`/email-templates/${organisation}`);
};

export const getEmailTemplateById = (organisation, id) => {
  return adminAxios.get(`/email-templates/${organisation}/${id}`);
};

export const createEmailTemplate = (body, organisation) => {
  return adminAxios.post(`/email-templates/${organisation}`, body);
};

export const updateEmailTemplate = (organisation, id, body) => {
  return adminAxios.put(`/email-templates/${organisation}/${id}`, body);
};

export const deleteEmailTemplate = (organisation, id) => {
  return adminAxios.delete(`/email-templates/${organisation}/${id}`);
};

export const getOrganizationProfessions = (organisation) => {
  return adminAxios.get(`/professions/${organisation}`);
};

export const getProfessionById = (organisation, id) => {
  return adminAxios.get(`/professions/${organisation}/${id}`);
};

export const createProfession = (body, organisation) => {
  return adminAxios.post(`/professions/${organisation}`, body);
};

export const updateProfession = (organisation, id, body) => {
  return adminAxios.put(`/professions/${organisation}/${id}`, body);
};

export const deleteProfession = (organisation, id) => {
  return adminAxios.delete(`/professions/${organisation}/${id}`);
};

// Custom PDFs
export const getCustomPdfs = (organisation) => {
  return adminAxios.get(`/custom-pdfs/${organisation}`);
};

export const getCustomPdfById = (organisation, id) => {
  return adminAxios.get(`/custom-pdfs/${organisation}/${id}`);
};

export const createCustomPdf = (body, organisation) => {
  return adminAxios.post(`/custom-pdfs/${organisation}`, body);
};

export const updateCustomPdf = (organisation, id, body) => {
  return adminAxios.put(`/custom-pdfs/${organisation}/${id}`, body);
};

export const deleteCustomPdf = (organisation, id) => {
  return adminAxios.delete(`/custom-pdfs/${organisation}/${id}`);
};

// Videos Pages
export const getVideosPages = (organisation) => {
  return adminAxios.get(`/videos-pages/${organisation}`);
};

export const getVideosPageById = (organisation, id) => {
  return adminAxios.get(`/videos-pages/${organisation}/${id}`);
};

export const createVideosPage = (body, organisation) => {
  return adminAxios.post(`/videos-pages/${organisation}`, body);
};

export const updateVideosPage = (organisation, id, body) => {
  return adminAxios.put(`/videos-pages/${organisation}/${id}`, body);
};

export const deleteVideosPage = (organisation, id) => {
  return adminAxios.delete(`/videos-pages/${organisation}/${id}`);
};

export const restoreVideosPage = (organisation, id) => {
  return adminAxios.patch(`/videos-pages/${organisation}/${id}/restore`);
};

// Videos Tips
export const getVideosTips = (organisation) => {
  return adminAxios.get(`/videos-tips/${organisation}`);
};

export const getVideosTipById = (organisation, id) => {
  return adminAxios.get(`/videos-tips/${organisation}/${id}`);
};

export const createVideosTip = (body, organisation) => {
  return adminAxios.post(`/videos-tips/${organisation}`, body);
};

export const updateVideosTip = (organisation, id, body) => {
  return adminAxios.put(`/videos-tips/${organisation}/${id}`, body);
};

export const deleteVideosTip = (organisation, id) => {
  return adminAxios.delete(`/videos-tips/${organisation}/${id}`);
};

export const restoreVideosTip = (organisation, id) => {
  return adminAxios.patch(`/videos-tips/${organisation}/${id}/restore`);
};

// Videos Examples
export const getVideosExamples = (organisation) => {
  return adminAxios.get(`/videos-examples/${organisation}`);
};

export const getVideosExampleById = (organisation, id) => {
  return adminAxios.get(`/videos-examples/${organisation}/${id}`);
};

export const createVideosExample = (body, organisation) => {
  return adminAxios.post(`/videos-examples/${organisation}`, body);
};

export const updateVideosExample = (organisation, id, body) => {
  return adminAxios.put(`/videos-examples/${organisation}/${id}`, body);
};

export const deleteVideosExample = (organisation, id) => {
  return adminAxios.delete(`/videos-examples/${organisation}/${id}`);
};

export const restoreVideosExample = (organisation, id) => {
  return adminAxios.patch(`/videos-examples/${organisation}/${id}/restore`);
};

// Professional Associations
export const getOrganizationProfessionalAssociations = (organisation) => {
  return adminAxios.get(`/professional-associations/${organisation}`);
};

export const createProfessionalAssociation = (body, organisation) => {
  return adminAxios.post(`/professional-associations/${organisation}`, body);
};

export const updateProfessionalAssociation = (organisation, id, body) => {
  return adminAxios.put(`/professional-associations/${organisation}/${id}`, body);
};

export const deleteProfessionalAssociation = (organisation, id) => {
  return adminAxios.delete(`/professional-associations/${organisation}/${id}`);
};

// Special Job Titles
export const getOrganizationSpecialJobTitles = (organisation) => {
  return adminAxios.get(`/special-job-titles/${organisation}`);
};

export const createSpecialJobTitle = (body, organisation) => {
  return adminAxios.post(`/special-job-titles/${organisation}`, body);
};

export const updateSpecialJobTitle = (organisation, id, body) => {
  return adminAxios.put(`/special-job-titles/${organisation}/${id}`, body);
};

export const deleteSpecialJobTitle = (organisation, id) => {
  return adminAxios.delete(`/special-job-titles/${organisation}/${id}`);
};
